module.exports = __webpack_public_path__ + "static/media/bet-blue-5.4954bdde.png";